import React from 'react'

class InProgressCircle extends React.Component {
  render() {
    return (
      <svg className="inProgressCircle" width="12" height="12" viewBox="0 0 12 12">
        <g fillRule="nonzero">
          <path
            fill="#ccc"
            d="M6 .75a5.25 5.25 0 1 1 0 10.5A5.25 5.25 0 0 1 6 .75zm0 .5a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5z"
            opacity=".5"
          />
          <path fill="#1b66b3" d="M6 1.9A4.1 4.1 0 1 1 1.9 6H.1A5.9 5.9 0 1 0 6 .1v1.8z" />
        </g>
      </svg>
    )
  }
}

export default InProgressCircle
